// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","819":"BusinessProVisitorLazyComponent"}[chunkId] + "." + {"46":"319448c3c3918e97f06c","819":"23c6931bfa0472792fd1"}[chunkId] + ".js";
};